import React from 'react'

import type { WCDRouteProps } from '..'
import { Page } from '../components/Page'

export const freeAccountRoutes: WCDRouteProps = [
  {
    live: true,
    exact: true,
    path: [
      '/news/article/my-dog-ate-the-post-again-hmrc-reveals-the-decades-worst-excuses-for-late-tax-returns-a7bAg9f5rQUE',
      '/news/article/the-cars-im-looking-forward-to-in-2026-awCCx5s1q92v',
    ],
    component: () => (
      <Page
        freeAccountPagePath="article/FreeAccountsArticlePage"
        context="news"
        pagePath="article/NonCommercialArticlePage"
      />
    ),
  },
]
